import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { GetUserAcceptanceTerm } from '@toro/common/shared/interfaces/operational-limit/operational-limit.interface';
import { LoMessages } from '@toro/common/shared/enum/banks/lo-messages.enum';

@Component({
    selector: 'hub-lo-revoke-confirmation-step',
    styleUrls: ['./revoke-confirmation-step.component.scss'],
    templateUrl: 'revoke-confirmation-step.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class HubLoRevokeConfirmationStepComponent {
    @Output() public closeDrawer = new EventEmitter<void>();
    @Output() public back = new EventEmitter<void>();
    @Output() public redirect = new EventEmitter<void>();
    @Input() public financialPending: boolean = false;
    @Input() public error: boolean = false;
    @Input() public operationalLimit: GetUserAcceptanceTerm;
    public readonly loMessages = LoMessages;
}
